/** The header the browser client sends with every API request, naming the locale it shows. */
export const LOCALE_HEADER = 'x-locale';
